import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { defineAsyncComponent } from 'vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: defineAsyncComponent(() => import('@/views/Home.vue')),
  },
  {
    path: "/Photos",
    name: "Add Photos",
    component: defineAsyncComponent(() => import('@/views/AddPage.vue'))
  },
  {
    path: "/Songs",
    name: "Add Songs",
    component: defineAsyncComponent(() => import('@/views/SongPage.vue'))
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
